import type { TourDefinition } from './types';

/**
 * One-scene pointer at the workspace switcher. Started directly after an
 * invitation is accepted (see `HomeView`) — accepting does not switch the
 * active organisation for users who already have one, so without it joining
 * looks like nothing happened. Also replayable from Help, with generic copy.
 */

/** Name of the organisation just joined; null outside the post-accept run. */
let joinedOrganisationName: string | null = null;

export function setJoinedOrganisation(name: string | null): void {
  joinedOrganisationName = name;
}

function clearJoinedOrganisation(): void {
  joinedOrganisationName = null;
}

export const organisationsTour: TourDefinition = {
  key: 'organisations',
  title: 'Switching organisations',
  description: 'Where to switch between the organisations you belong to.',
  onComplete: clearJoinedOrganisation,
  onExit: clearJoinedOrganisation,
  steps: [
    {
      id: 'switcher',
      route: 'home',
      target: 'sidebar.workspace',
      placement: 'right-start',
      title: 'Switch organisations here',
      body: () =>
        joinedOrganisationName
          ? `You joined ${joinedOrganisationName}. You can switch your organisation here, ` +
            'and you keep access to every organisation you belong to.'
          : 'You can belong to several organisations. Switch between them here.',
    },
  ],
};
